import { useRequestMutation } from "hooks/useRequest";
import { Chat, Reference } from "models/AiResearch";
import { useState } from "react";

export const useReference = ({ result }: { result: Chat }) => {
  const [reference, setReference] = useState<Reference | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  // 情報ソースの詳細を取得するAPI
  const { trigger: fetchSourceLink } = useRequestMutation<{
    body: string | null;
    keyPdf: string | null;
    sourceLink: string | null;
  }>("/sse/query/rag/source-link", "GET");

  // PDFデータを取得するAPI
  const { trigger: fetchSourcePdf } = useRequestMutation<string>(
    "/sse/query/rag/source-pdf",
    "GET"
  );

  // 引用情報を取得する関数
  const fetchReference = async ({
    questionId,
    citationNo
  }: {
    questionId: string;
    citationNo: number;
  }) => {
    setIsLoading(true);

    try {
      const data = await fetchSourceLink({
        questionId,
        citationNo
      });
      const history = result.history.find(
        item => item.ids?.questionId === questionId
      );
      const reference = history?.reference?.find(
        item => item.citationNumber === citationNo
      );

      if (!reference) {
        setReference(null);
        return;
      }

      setReference({
        ...reference,
        body: data.body,
        keyPdf: data.keyPdf,
        sourceLink: data.sourceLink
      });

      if (data.keyPdf) {
        const pdfData = await fetchSourcePdf({
          keyPdf: data.keyPdf
        });
        setReference(prev => (prev ? { ...prev, sourcePdf: pdfData } : null));
      }
    } finally {
      setIsLoading(false);
    }
  };

  // 選択中の引用情報をクリアする
  const clearReference = () => {
    setReference(null);
  };

  return { reference, isLoading, fetchReference, clearReference };
};
